import { useState } from "react";

const AccordionImage = ({ imageSrc, altText }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen((prev) => !prev);
  };

  const preventSelection = (event) => {
    event.preventDefault();
  };

  return (
    <div className="accordion-container">
      <div className="accordion-header" onClick={toggleAccordion}>
      사업자 정보보기 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="24" height="24">
  <path fill="#A9A9A9" d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/>
</svg>



      </div>
      <div className={`accordion-content ${isOpen ? "open" : "closed"}`}>
        <img
          src={imageSrc}
          alt={altText}
          className="blog-image no-pointer-events"
          onMouseDown={preventSelection}
          onTouchStart={preventSelection}
        />
      </div>

      <style jsx>{`
        .accordion-container {
          width: 100%;
          max-width: 600px;
        }
        .accordion-header {
          cursor: pointer;
            padding: 10px;
            background-color: #f1f1f1;
            border: 1px solid #ccc;
            text-align: center;
            font-weight: bold;
            font-size: 1.5rem;
        }
        .accordion-content {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease-in-out;
        }
        .accordion-content.open {
          max-height: 300px; /* 적절한 높이 조정 */
        }
          .downIconAccordion{
          background-color: black;
          color: black;
            width: 20px;
            height: 20px;
            margin-left: 10px;}
      `}</style>
    </div>
  );
};

export default AccordionImage;
